import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {isSlowConnection} from '../common/network';

import {WINDOW} from '../app/config/module.di.tokens';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WelcomeVideoService {

  window = inject(WINDOW)
  document = inject(DOCUMENT)
  platformId = inject(PLATFORM_ID)

  loadVideo() {
    if(isPlatformBrowser(this.platformId)) {
      if (this.document.readyState === 'complete') {
        this.doLoad();
      } else {
        this.window.addEventListener('load', () => {
          if ('requestIdleCallback' in this.window) {
            requestIdleCallback(() => this.doLoad(), { timeout: 2000 });
          } else {
            setTimeout(() => this.doLoad(), 200);
          }
        });
      }
    }
  }

  private doLoad() {

    console.log('Load Video')
    const video = this.document.getElementById('welcome-video') as HTMLVideoElement;

    if (isSlowConnection()) {
      video.preload = 'none';
      video.autoplay = false
      video.poster = environment.welcomeVideoUrl.poster

    } else {

      const sourceDesktop = this.document.getElementById('source-desktop') as HTMLSourceElement;
      sourceDesktop.src = environment.welcomeVideoUrl.desktop;

      const sourceMobile = this.document.getElementById('source-mobile') as HTMLSourceElement;
      sourceMobile.src = environment.welcomeVideoUrl.mobile

      video.preload = 'auto';
      video.muted = true;
      video.defaultMuted = true;
      video.load();
      video.play().catch((error) => {
        console.error(error)
      });
    }
  }
}
